/**
 * mk-account-svc
 * 账户体系
 *
 * OpenAPI spec version: last
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import ajax, { AjaxPromise, ExtraFetchParams } from '@ajax';
import * as models from '../model/models';

/* tslint:disable:no-unused-variable member-ordering object-literal-shorthand */

/**
  */
export type ParamsBodyenterpriseInfoCreatePost = models.EnterpriseInfoCreateBody;
/**
  * @description enterpriseInfoDetailGet参数
  * @property `corpId` 企业Id
  */
export interface ParamsenterpriseInfoDetailGet {
  // queryParams
  /**
   * 企业Id
   */
  corpId: string;
}
/**
  * @description enterpriseInfoQwDetailGet参数
  * @property `corpId` 企业ID
  */
export interface ParamsenterpriseInfoQwDetailGet {
  // queryParams
  /**
   * 企业ID
   */
  corpId: string;
}
/**
  * @description v1AgencyPlatformEnterpriseInfoGet参数
  * @property `id` 公司id
  */
export interface Paramsv1AgencyPlatformEnterpriseInfoGet {
  // queryParams
  /**
   * 公司id
   */
  id: string;
}
/**
  */
export type ParamsBodyv1EnterpriseInfoCreatePost = models.V1EnterpriseInfoCreateBody;
/**
  * @description v1EnterpriseInfoDetailGet参数
  * @property `corpId` 企业Id
  */
export interface Paramsv1EnterpriseInfoDetailGet {
  // queryParams
  /**
   * 企业Id
   */
  corpId: string;
}
/**
  * @description v1EnterpriseInfoGet参数
  * @property `corpId` 企业Id
  */
export interface Paramsv1EnterpriseInfoGet {
  // queryParams
  /**
   * 企业Id
   */
  corpId: string;
}
/**
  * @description v1EnterpriseInfoQwDetailGet参数
  * @property `corpId` 企业ID
  */
export interface Paramsv1EnterpriseInfoQwDetailGet {
  // queryParams
  /**
   * 企业ID
   */
  corpId: string;
}

export class EnterpriseInfoApi {
  protected $basePath = '/account'.replace(/\/$/, '');

  public constructor(basePath?: string) {
    if (basePath !== undefined) {
      this.$basePath = basePath.replace(/\/$/, '');
    }
  }

  /**
   * 
   * @summary 新增企业信息
   
   * @param data: ParamsBodyenterpriseInfoCreatePost
   * @param opt ajax config
   * @returns models.InternalAccountV1CompanyConfig
   */
  public enterpriseInfoCreatePost = (
    
    data: ParamsBodyenterpriseInfoCreatePost,opt?: ExtraFetchParams
  ) : AjaxPromise<models.InternalAccountV1CompanyConfig>  => {
    const path = '/enterprise_info/create';
    const url = this.$basePath + path;
    const p: any = {};
    p.data = data;
    return ajax.ajax({
      ...opt,
      method: 'POST',
      url,
      ...p
    });
  }
  /**
   * 
   * @summary 获取企业信息
   * @param params ParamsenterpriseInfoDetailGet
   
   * @param opt ajax config
   * @returns models.EnterpriseInfoDetail
   */
  public enterpriseInfoDetailGet = (
    params: ParamsenterpriseInfoDetailGet,
    opt?: ExtraFetchParams
  ) : AjaxPromise<models.EnterpriseInfoDetail>  => {
    const path = '/enterprise_info/detail';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('corpId' in params) p.query.corpId = params.corpId;
    ajax.check(params.corpId, 'corpId');
    return ajax.ajax({
      ...opt,
      method: 'GET',
      url,
      ...p
    });
  }
  /**
   * 
   * @summary 获取企业信息（QW）
   * @param params ParamsenterpriseInfoQwDetailGet
   
   * @param opt ajax config
   * @returns models.EnterpriseInfoDetail
   */
  public enterpriseInfoQwDetailGet = (
    params: ParamsenterpriseInfoQwDetailGet,
    opt?: ExtraFetchParams
  ) : AjaxPromise<models.EnterpriseInfoDetail>  => {
    const path = '/enterprise_info/qw/detail';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('corpId' in params) p.query.corpId = params.corpId;
    ajax.check(params.corpId, 'corpId');
    return ajax.ajax({
      ...opt,
      method: 'GET',
      url,
      ...p
    });
  }
  /**
   * 
   * @summary 运营中心登录页-获取企业信息
   * @param params Paramsv1AgencyPlatformEnterpriseInfoGet
   
   * @param opt ajax config
   * @returns models.V1EnterpriseInfo
   */
  public v1AgencyPlatformEnterpriseInfoGet = (
    params: Paramsv1AgencyPlatformEnterpriseInfoGet,
    opt?: ExtraFetchParams
  ) : AjaxPromise<models.V1EnterpriseInfo>  => {
    const path = '/v1/agency_platform/enterprise_info';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('id' in params) p.query.id = params.id;
    ajax.check(params.id, 'id');
    return ajax.ajax({
      ...opt,
      method: 'GET',
      url,
      ...p
    });
  }
  /**
   * 
   * @summary 新增企业信息
   
   * @param data: ParamsBodyv1EnterpriseInfoCreatePost
   * @param opt ajax config
   * @returns models.InternalAccountV1CompanyConfig
   */
  public v1EnterpriseInfoCreatePost = (
    
    data: ParamsBodyv1EnterpriseInfoCreatePost,opt?: ExtraFetchParams
  ) : AjaxPromise<models.InternalAccountV1CompanyConfig>  => {
    const path = '/v1/enterprise_info/create';
    const url = this.$basePath + path;
    const p: any = {};
    p.data = data;
    return ajax.ajax({
      ...opt,
      method: 'POST',
      url,
      ...p
    });
  }
  /**
   * 
   * @summary 获取企业信息
   * @param params Paramsv1EnterpriseInfoDetailGet
   
   * @param opt ajax config
   * @returns models.V1EnterpriseInfoDetail
   */
  public v1EnterpriseInfoDetailGet = (
    params: Paramsv1EnterpriseInfoDetailGet,
    opt?: ExtraFetchParams
  ) : AjaxPromise<models.V1EnterpriseInfoDetail>  => {
    const path = '/v1/enterprise_info/detail';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('corpId' in params) p.query.corpId = params.corpId;
    ajax.check(params.corpId, 'corpId');
    return ajax.ajax({
      ...opt,
      method: 'GET',
      url,
      ...p
    });
  }
  /**
   * 
   * @summary 登录页-获取企业信息
   * @param params Paramsv1EnterpriseInfoGet
   
   * @param opt ajax config
   * @returns models.V1EnterpriseInfo
   */
  public v1EnterpriseInfoGet = (
    params: Paramsv1EnterpriseInfoGet,
    opt?: ExtraFetchParams
  ) : AjaxPromise<models.V1EnterpriseInfo>  => {
    const path = '/v1/enterprise_info';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('corpId' in params) p.query.corpId = params.corpId;
    ajax.check(params.corpId, 'corpId');
    return ajax.ajax({
      ...opt,
      method: 'GET',
      url,
      ...p
    });
  }
  /**
   * 
   * @summary 获取企业产品权限信息
   
   
   * @param opt ajax config
   * @returns models.V1EnterpriseInfoProducts
   */
  public v1EnterpriseInfoProductsGet = (
    
    opt?: ExtraFetchParams
  ) : AjaxPromise<models.V1EnterpriseInfoProducts>  => {
    const path = '/v1/enterprise_info/products';
    const url = this.$basePath + path;
    const p: any = {};
    return ajax.ajax({
      ...opt,
      method: 'GET',
      url,
      ...p
    });
  }
  /**
   * 
   * @summary 获取企业信息（QW）
   * @param params Paramsv1EnterpriseInfoQwDetailGet
   
   * @param opt ajax config
   * @returns models.V1EnterpriseInfoDetail
   */
  public v1EnterpriseInfoQwDetailGet = (
    params: Paramsv1EnterpriseInfoQwDetailGet,
    opt?: ExtraFetchParams
  ) : AjaxPromise<models.V1EnterpriseInfoDetail>  => {
    const path = '/v1/enterprise_info/qw/detail';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('corpId' in params) p.query.corpId = params.corpId;
    ajax.check(params.corpId, 'corpId');
    return ajax.ajax({
      ...opt,
      method: 'GET',
      url,
      ...p
    });
  }
}

export default new EnterpriseInfoApi();